export default {
  methods: {
    log(...args) { // rest parameters
      console.log(...args); // spread operator
    },
  },
};
